























































import { Vue, Component, Prop } from "vue-property-decorator";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { UsersListClass } from "@/classes/list/UsersListClass";
import { Disk as IDisk } from "@/api-v2/files/models/disk";
import { User as IUser } from "@/api/models/user";

@Component({
  components: { CustomButton, CSingleSelect }
})
export default class CFileManagerAccess extends Vue {
  @Prop() disk!: IDisk;
  usersList: UsersListClass = new UsersListClass({});
  mode: "add" | "remove" = "remove";
  searchUserInput: string = "";
  userForAdded?: IUser;

  data() {
    return {
      userForAdded: undefined
    };
  }

  get users() {
    return this.disk?.writeUsers
      ?.filter(el =>
        el.fullName
          ?.toLowerCase()
          ?.includes(this.searchUserInput?.toLowerCase())
      )
      ?.sort();
  }
  changeMode(mode: "add" | "remove") {
    this.mode = mode;
  }

  closeAccessForUser(userId: string) {
    this.$emit("closeAccess", userId);
    this.searchUserInput = "";
  }

  addUser() {
    const isUserHasAccesses = !!this.disk?.writeUsers?.find(
      el => el.id === this.userForAdded!.id
    );

    if (!isUserHasAccesses) {
      this.$emit("addUser", this.userForAdded!.id);
      this.userForAdded = undefined;
    } else {
      this.$store.dispatch("localError", "У пользователя уже есть доступ");
    }
  }
}
